<template>
 <h1>Code usage</h1>
</template>

<script>

export default {
	name: 'code-usage'
}

</script>
